<template>
  <div :class="$style['pt-checkbox']">
    <div v-for="(item, index) in data" :key="index" class="item">
      <div class="checkbox-border">
        <span
          v-if="
            item.value
              ? (value && value.indexOf(item.value) > -1) ||
                value === item.value
              : (value && value.indexOf(item) > -1) || value === item
          "
          >√</span
        >
      </div>
      {{ item.label ? item.label : item }}
      <!-- <input
        type="checkbox"
        :value="item.value ? item.value : item"
        v-model="currentValue"
        onclick="return false"
      />{{ item.label ? item.label : item }}
      <slot v-if="item.slot" /> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    value: [Boolean, String, Array],
    disabled: Boolean,
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  methods: {
    change() {
      return false;
    },
  },
};
</script>
<style module lang="less">
.pt-checkbox {
  width: 100%;
  display: flex;
  // white-space: nowrap;
  flex-flow: wrap;
  :global {
    .item {
      display: flex;
      align-items: center;
      padding-right: 8px;
      + .item {
      }
    }
    .checkbox-border {
      border: 1px solid #000;
      width: 10px;
      height: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 3px;
      > span {
        padding-bottom: 5px;
      }
    }
  }
  input:disabled {
    color: #000;
    border-color: #000;
    background-color: #fff;
  }
  input:checked::after {
    color: red;
  }
}
</style>
